<template>
    <div class="com-calendar-info-bar dsp-flex">
        <div class="com-calendar-info-date">
            <p>{{todayInfo.solar.y}}年{{todayInfo.solar.m}}月</p>
            <div class="com-calendar-info-day">
                <span class="text-day">{{todayInfo.solar.d}}</span>
                <span v-show="todayInfo.jie != ''" class="text-festival">{{todayInfo.jie}}</span>
            </div>
        </div>
        <div class="com-calendar-info-week">
            <p>{{todayInfo.solar.week}}</p>
        </div>
        <div class="com-calendar-info-detail">
            <p class="text-year-month"><span>{{todayInfo.lunar.y}}年</span> <span>{{todayInfo.lunar.m}}月</span></p>
            <p class="text-day2">
                <span v-bind:class="'wd-' + todayInfo.lunar.rg.propXingEn">{{todayInfo.lunar.rg.text}}</span><span v-bind:class="'wd-' + todayInfo.lunar.rz.propXingEn">{{todayInfo.lunar.rz.text}}</span>日
            </p>
        </div>
        <div class="com-calendar-info-lunar">
            <p v-bind:class="{'text-date-5': todayInfo.lunar.date.length == 5, 'text-date-6': todayInfo.lunar.date.length == 6}">{{todayInfo.lunar.date}}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CalendarInfoBar',
    computed: {
        todayInfo() {
            return this.$store.state.collate.calendarinfo.todayInfo;
        }
    },
    created: function() {
        if(!this.todayInfo.solar){
            this.$store.dispatch('collate/calendarinfo/initTodayInfo');
        }
    },
    methods: {

    }
}
</script>